import { useState, useCallback } from "react";

import { Api } from "interfaces";
import { ApiError } from "api";

import Alert from "ui-components/Alert";
import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import InputField from "ui-components/Input-Field";

import { useGetUpdateName } from "modules/data-files/api";
import Divider from "ui-components/Divider";

interface Props {
  dataFileId: string;
  currentName?: string | null | undefined;
  size?: "small" | "medium" | "large";
}

const Rename = ({ dataFileId, currentName, size = "small" }: Props) => {
  const updateProjectName = useGetUpdateName(dataFileId);
  const [newName, setNewName] = useState<string>();
  const [submitStatus, setSubmitStatus] = useState<
    "not-started" | "in-progress" | "completed"
  >("not-started");
  const [error, setError] = useState<Api.ApiError>();

  const [showModal, setShowModal] = useState(false);

  const updateNewName = useCallback(
    (v: string | null | undefined) => {
      setNewName(v);
    },
    [setNewName]
  );

  const openModal = () => {
    setShowModal(true);
    setSubmitStatus("not-started");
  };
  const closeModal = () => setShowModal(false);

  const updateName = useCallback(async () => {
    setSubmitStatus("in-progress");
    try {
      await updateProjectName(newName);
      setShowModal(false);
      setSubmitStatus("completed");
    } catch (e) {
      setError(e as Api.ApiError);
    }
    setSubmitStatus("completed");
  }, [newName, updateProjectName, setShowModal, setSubmitStatus]);

  return (
    <div>
      <Button onClick={openModal} color="gray" size={size}>
        UPDATE NAME
      </Button>
      <Modal
        id={`rename-${dataFileId}`}
        ariaLabel={`rename-${dataFileId}`}
        show={showModal}
        handleClose={closeModal}
        title={
          <p className="h4">Update name for {currentName || dataFileId}</p>
        }
      >
        <div>
          <div>
            <InputField
              label="New Name"
              type="text"
              help={
                currentName ? (
                  <span>
                    The project's current name is{" "}
                    <span className="font-semibold italic">{currentName}</span>
                  </span>
                ) : (
                  <span>The project doesnt have a name yet.</span>
                )
              }
              value={newName}
              onChange={updateNewName}
              placeholder="New Name"
            />
            {error && (
              <div className="mt-4">
                <ApiError error={error} />
              </div>
            )}
            {submitStatus === "completed" && !error && (
              <div className="mt-4">
                <Alert variant="success">Successfully Shared!!!</Alert>
              </div>
            )}
            <Divider />
            <div className="text-right">
              <Button onClick={() => closeModal} color="gray">
                Close
              </Button>
              <Button
                onClick={updateName}
                loading={submitStatus === "in-progress"}
                disabled={!newName}
              >
                Update
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Rename;
